export default "__VITE_ASSET__79652fa8__"